import githubIcon from '../images/url-icon/github-icon.png'
import githubIconLight from '../images/url-icon/github-icon-light.png'
import linkedinIcon from '../images/url-icon/linkedin-icon.png'
import tstoryIcon from '../images/url-icon/tstory-icon.png'
import notionIcon from '../images/url-icon/notion-icon.png'
import appleAppstoreIcon from '../images/url-icon/apple-appstore.png'
import googleChrome from '../images/url-icon/google-chrome.png'
import raycast from '../images/icons/raycast.png'
import generalLink from '../images/icons/link.png'
import tossIcon from '../images/url-icon/toss.png'

import booksitoutIcon from '../images/icons/booksitout.png'
import boldPeopleIcon from '../images/icons/boldPeople.png'
import purrfitTrackerIcon from '../images/icons/purrfitTracker.png'
import substrackIcon from '../images/icons/substrack.png'
import springfeedIcon from '../images/icons/springfeed-logo.png'
import featuredDaysIcon from '../images/icons/featureddaysicon.png'
import pianomanIcon from '../images/icons/pianoman.png'
import lostThingsIcon from '../images/icons/lostThings.png'

const WebsiteIcon = {
    github: githubIcon,
    githubLight: githubIconLight,
    tstory: tstoryIcon,
    linkedin: linkedinIcon,
    notion: notionIcon,
    appleAppstore: appleAppstoreIcon,
    link: generalLink,
    googleChrome: googleChrome,
    raycast: raycast,

    booksitout: booksitoutIcon,
    boldPeople: boldPeopleIcon,
    purrfitTracker: purrfitTrackerIcon,
    substrackIcon: substrackIcon,
    springfeed: springfeedIcon,
    featuredDays: featuredDaysIcon,
    pianoman: pianomanIcon,
    lostThings: lostThingsIcon,
    toss: tossIcon,
}

export default WebsiteIcon